export default "__VITE_ASSET__912ece45__"